import _definePage_default_0 from '/app/resources/ts/pages/[[id]].vue?definePage&vue&lang.tsx'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'
import _definePage_default_2 from '/app/resources/ts/pages/[...path].vue?definePage&vue&lang.tsx'
import _definePage_default_3 from '/app/resources/ts/pages/auth/index.vue?definePage&vue&lang.tsx'
import _definePage_default_4 from '/app/resources/ts/pages/auth/otp.vue?definePage&vue&lang.tsx'
import _definePage_default_5 from '/app/resources/ts/pages/auth/social/[provider]/login/index.vue?definePage&vue&lang.tsx'
import _definePage_default_6 from '/app/resources/ts/pages/consultations/chat.vue?definePage&vue&lang.tsx'
import _definePage_default_7 from '/app/resources/ts/pages/content/pages/[slug].vue?definePage&vue&lang.tsx'
import _definePage_default_8 from '/app/resources/ts/pages/profile/index.vue?definePage&vue&lang.tsx'
import _definePage_default_9 from '/app/resources/ts/pages/profile/consultations/index.vue?definePage&vue&lang.tsx'
import _definePage_default_10 from '/app/resources/ts/pages/profile/password.vue?definePage&vue&lang.tsx'
import _definePage_default_11 from '/app/resources/ts/pages/profile/subscriptions/index.vue?definePage&vue&lang.tsx'
import _definePage_default_12 from '/app/resources/ts/pages/subscriptions/index.vue?definePage&vue&lang.tsx'
import _definePage_default_13 from '/app/resources/ts/pages/subscriptions/success.vue?definePage&vue&lang.tsx'

export const routes = [
  _mergeRouteRecord(
    {
      path: '/:id?',
      name: 'root',
      component: () => import('/app/resources/ts/pages/[[id]].vue'),
      /* no children */
    },
    _definePage_default_0
  ),
  _mergeRouteRecord(
    {
      path: '/:path(.*)',
      name: '$path',
      component: () => import('/app/resources/ts/pages/[...path].vue'),
      /* no children */
    },
    _definePage_default_2
  ),
  {
    path: '/auth',
    /* internal name: 'auth' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: '',
          name: 'auth',
          component: () => import('/app/resources/ts/pages/auth/index.vue'),
          /* no children */
        },
        _definePage_default_3
      ),
      _mergeRouteRecord(
        {
          path: 'otp',
          name: 'auth-otp',
          component: () => import('/app/resources/ts/pages/auth/otp.vue'),
          /* no children */
        },
        _definePage_default_4
      ),
      {
        path: 'social',
        /* internal name: 'auth-social' */
        /* no component */
        children: [
          {
            path: ':provider',
            /* internal name: 'auth-social-provider' */
            /* no component */
            children: [
              {
                path: 'login',
                /* internal name: 'auth-social-provider-login' */
                /* no component */
                children: [
                  _mergeRouteRecord(
                    {
                      path: '',
                      name: 'auth-social-provider-login',
                      component: () => import('/app/resources/ts/pages/auth/social/[provider]/login/index.vue'),
                      /* no children */
                    },
                    _definePage_default_5
                  )
                ],
              }
            ],
          }
        ],
      }
    ],
  },
  {
    path: '/consultations',
    /* internal name: 'consultations' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: 'chat',
          name: 'consultations-chat',
          component: () => import('/app/resources/ts/pages/consultations/chat.vue'),
          /* no children */
        },
        _definePage_default_6
      )
    ],
  },
  {
    path: '/content',
    /* internal name: 'content' */
    /* no component */
    children: [
      {
        path: 'pages',
        /* internal name: 'content-pages' */
        /* no component */
        children: [
          _mergeRouteRecord(
            {
              path: ':slug',
              name: 'content-pages-slug',
              component: () => import('/app/resources/ts/pages/content/pages/[slug].vue'),
              /* no children */
            },
            _definePage_default_7
          )
        ],
      }
    ],
  },
  {
    path: '/profile',
    /* internal name: 'profile' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: '',
          name: 'profile',
          component: () => import('/app/resources/ts/pages/profile/index.vue'),
          /* no children */
        },
        _definePage_default_8
      ),
      {
        path: 'consultations',
        /* internal name: 'profile-consultations' */
        /* no component */
        children: [
          _mergeRouteRecord(
            {
              path: '',
              name: 'profile-consultations',
              component: () => import('/app/resources/ts/pages/profile/consultations/index.vue'),
              /* no children */
            },
            _definePage_default_9
          ),
          {
            path: ':id',
            name: 'profile-consultations-id',
            component: () => import('/app/resources/ts/pages/profile/consultations/[id].vue'),
            /* no children */
          }
        ],
      },
      _mergeRouteRecord(
        {
          path: 'password',
          name: 'profile-password',
          component: () => import('/app/resources/ts/pages/profile/password.vue'),
          /* no children */
        },
        _definePage_default_10
      ),
      {
        path: 'subscriptions',
        /* internal name: 'profile-subscriptions' */
        /* no component */
        children: [
          _mergeRouteRecord(
            {
              path: '',
              name: 'profile-subscriptions',
              component: () => import('/app/resources/ts/pages/profile/subscriptions/index.vue'),
              /* no children */
            },
            _definePage_default_11
          ),
          {
            path: ':id',
            name: 'profile-subscriptions-id',
            component: () => import('/app/resources/ts/pages/profile/subscriptions/[id].vue'),
            /* no children */
          },
          {
            path: 'cancel',
            name: 'profile-subscriptions-cancel',
            component: () => import('/app/resources/ts/pages/profile/subscriptions/cancel.vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/subscriptions',
    /* internal name: 'subscriptions' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: '',
          name: 'subscriptions',
          component: () => import('/app/resources/ts/pages/subscriptions/index.vue'),
          /* no children */
        },
        _definePage_default_12
      ),
      {
        path: 'failed',
        name: 'subscriptions-failed',
        component: () => import('/app/resources/ts/pages/subscriptions/failed.vue'),
        /* no children */
      },
      {
        path: 'processing',
        name: 'subscriptions-processing',
        component: () => import('/app/resources/ts/pages/subscriptions/processing.vue'),
        /* no children */
      },
      _mergeRouteRecord(
        {
          path: 'success',
          name: 'subscriptions-success',
          component: () => import('/app/resources/ts/pages/subscriptions/success.vue'),
          /* no children */
        },
        _definePage_default_13
      )
    ],
  }
]

export function handleHotUpdate(_router, _hotUpdateCallback) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
    import.meta.hot.data.router_hotUpdateCallback = _hotUpdateCallback
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    // call the hotUpdateCallback for custom updates
    import.meta.hot.data.router_hotUpdateCallback?.(mod.routes)
    const route = router.currentRoute.value
    router.replace({
      ...route,
      // NOTE: we should be able to just do ...route but the router
      // currently skips resolving and can give errors with renamed routes
      // so we explicitly set remove matched and name
      name: undefined,
      matched: undefined,
      force: true
    })
  })
}

